import React from 'react';
export default function AppFooter() {
    return (React.createElement("div", { className: "footer-section" }, "\u00A9 Mateusz S\u0142omka"));
}
